import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { format, parseISO } from "date-fns";
import { AlertTriangle, MessageSquare } from "lucide-react";

const Count = ({ label, value, tone }) => (
  <div className="py-6 px-2" data-testid={`sms-week-${label.toLowerCase()}`}>
    <div className="label-caps text-muted-foreground">{label}</div>
    <div className={`font-serif text-4xl mt-2 tracking-tight ${tone}`}>{value ?? "—"}</div>
  </div>
);

export default function SmsWeekCard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/sms/weekly-summary").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <div className="mt-12" data-testid="sms-week-card">
      <div className="flex items-center justify-between mb-4">
        <div className="label-caps text-muted-foreground flex items-center gap-2"><MessageSquare className="w-4 h-4 text-brand" /> Texts this week</div>
        <Link to="/settings/sms" className="text-sm text-brand hover:underline" data-testid="sms-week-view-all">View SMS history</Link>
      </div>
      <div className="grid grid-cols-3 divide-x divide-border/60 border-y border-border/60">
        <Count label="Sent" value={data?.sent} tone="text-brand-gradient" />
        <Count label="Delivered" value={data?.delivered} tone="text-[hsl(140_60%_35%)]" />
        <Count label="Failed" value={data?.failed} tone={data?.failed ? "text-destructive" : "text-muted-foreground"} />
      </div>
      {data?.test_mode > 0 && (
        <p className="text-xs text-muted-foreground mt-3" data-testid="sms-week-test-mode">
          {data.test_mode} message{data.test_mode > 1 ? "s" : ""} logged in test mode (live sending is off).
        </p>
      )}
      {data?.failed_messages?.length > 0 && (
        <div className="mt-6 divide-y divide-border/60 border border-destructive/30 rounded-sm" data-testid="sms-week-failed-list">
          {data.failed_messages.map((m) => (
            <div key={m.id} className="flex items-center justify-between gap-4 px-5 py-3 text-sm" data-testid={`sms-week-failed-${m.id}`}>
              <div className="flex items-center gap-3 min-w-0">
                <AlertTriangle className="w-4 h-4 text-destructive shrink-0" />
                <div className="min-w-0">
                  <div className="font-medium truncate">{m.customer_name || m.to} <span className="text-muted-foreground font-normal">· {m.to}</span></div>
                  <div className="text-xs text-muted-foreground truncate">{m.error || "Delivery failed"} · {m.created_at ? format(parseISO(m.created_at), "EEE d MMM, h:mma") : ""}</div>
                </div>
              </div>
              {m.job_id ? (
                <Link to={`/jobs?job=${m.job_id}`} className="text-brand hover:underline shrink-0" data-testid={`sms-week-failed-link-${m.id}`}>Open booking</Link>
              ) : <span className="text-xs text-muted-foreground capitalize shrink-0">{(m.kind || "").replace("_", " ")}</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
